import React, { Suspense, ComponentType } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import './lazyLoad.css';

// HOC para lazy loading con fallback personalizado
export const withSuspense = <P extends object>(
  Component: ComponentType<P>,
  fallback?: React.ReactElement
) => {
  const WrappedComponent = (props: P) => (
    <Suspense
      fallback={
        fallback || (
          <div className="lazy-loading-container">
            <Spinner size={SpinnerSize.large} label="Cargando..." />
          </div>
        )
      }
    >
      <Component {...props} />
    </Suspense>
  );
  
  WrappedComponent.displayName = `withSuspense(${Component.displayName || Component.name})`;
  return WrappedComponent;
};

// Función helper para crear lazy components
export const createLazyComponent = <T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  fallback?: React.ReactElement
) => {
  const LazyComponent = React.lazy(importFunc);
  return withSuspense(LazyComponent, fallback);
};